import { getApp } from "firebase/app";
import {
  collection,
  getFirestore,
  onSnapshot,
  Timestamp,
} from "firebase/firestore";
import { useEffect, useState } from "react";

import type { EventCollectionId } from "../workspace/collectionIds";

export type EventUnitRelease = {
  unlocked: boolean;
  unlockAt?: Date;
  unlockedAt?: Date;
};

const readDate = (raw: unknown): Date | undefined => {
  if (raw instanceof Timestamp) {
    return raw.toDate();
  }
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    return raw;
  }
  return undefined;
};

export function useEventUnitReleases(
  eventId: EventCollectionId | null
): Record<string, EventUnitRelease> {
  const [releases, setReleases] = useState<Record<string, EventUnitRelease>>(
    {}
  );

  useEffect(() => {
    if (!eventId) {
      setReleases({});
      return;
    }

    const db = getFirestore(getApp());
    const releasesRef = collection(
      db,
      "accounts",
      eventId.accountId,
      "events",
      eventId.eventId,
      "unitRelease"
    );

    const unsubscribe = onSnapshot(releasesRef, (snapshot) => {
      const next: Record<string, EventUnitRelease> = {};
      for (const doc of snapshot.docs) {
        const data = doc.data();
        next[doc.id] = {
          unlocked: data.unlocked === true,
          unlockAt: readDate(data.unlockAt),
          unlockedAt: readDate(data.unlockedAt),
        };
      }
      setReleases(next);
    });

    return unsubscribe;
  }, [eventId]);

  return releases;
}
